import React, { PureComponent } from 'react';
import { STATUS } from '../../../../redux/constants';
import history from '../../../../redux/history';
import {
  Table,
  Button,
  Form,
  Input,
  Checkbox,
  Select,
  Menu,
  Dropdown,
  Space,
  DatePicker,
  Tooltip,
  Typography,
  Row,
  Col,
  Modal,
  Pagination,
} from 'antd';
import Icon, {
  SearchOutlined,
  EditOutlined,
  WarningOutlined,
  ArrowLeftOutlined,
} from '@ant-design/icons';
import styles from './customers.module.sass';
import cx from 'classnames';
import Panel from '../../../../shared-components/Panel';
import CountrySelect from '../../../../shared-components/CountrySelect';
import moment from 'moment-timezone';
import { ReactComponent as three_dots_icon } from '../../../../assets/icons/ThreeDots.svg';
import { confirmDelete } from '../../../../shared-components/DeleteConfirm';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import { formatEmail } from '../../../../redux/utils/email';

const { Paragraph, Title, Text } = Typography;

class Customers extends PureComponent {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      enrichmentAccessDisabled: false,
      queryBuilderAccessDisabled: false,
      limitedQueryBuilderAccessDisabled: false,
      exploreAccessDisabled: false,
      monitoringAccessDisabled: false,

      currentSelectedBulkDataFeeds: [], //remove after transition
      currentSelectedBulkDataFeedsOptions: [], //remove after transition

      currentSelectedMarketplaceDataFeeds: [],
      currentlySelectedMarketplaceDataFeedDownloadOptions: [],
      currentlySelectedMarketplaceDataFeedVisibilityOptions: [],
      initialLoad: true,
    };
  }

  state = {
    action: 'list',
    currentCustomer: null,
    currentCustomerSubscription: null,
    customerSubscriptionPlan: null,
    selectedPlan: null,
    currentPage: 1,
    searchText: '',
    communityCustomer: false,
    permissionFormValues: null,
    activateOrgModal: false,
    currentSelectedOrganization: [],
    activateOrgLoading: false,
    activateOrgExpirationDate: null,
  };

  componentDidMount() {
    this.props.resetCreateOrganizationStatus();
    this.props.loadMySubscriptionPlan();
    this.props.loadDataMarketplaceFeedOptions();
    this.props.loadCustomerOrganizationsList();
    this.props.changeTitle('Customers', null);
    document.title = 'Customers - Silent Push';
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      currentSelectedBulkDataFeeds, //remove after transition
      selectedPlan,
      currentlySelectedMarketplaceDataFeedDownloadOptions,
      currentlySelectedMarketplaceDataFeedVisibilityOptions,
      initialLoad,
    } = this.state;

    if (this.props.customerSubscriptionPlanStatus == STATUS.LOADED) {
      //this section is for selecting a plan on the organisation creation

      this.setState({
        customerSubscriptionPlan: this.props.customerSubscriptionPlan,
      });
      if (
        this.formRef.current &&
        prevProps?.customerSubscriptionPlan?.uuid != this.state.selectedPlan
      ) {
        this.formRef.current.setFieldsValue({
          expiration_date:
            this.props.customerSubscriptionPlan?.description?.toLowerCase() ===
            'community'
              ? moment().add(90, 'days')
              : undefined,
          seats_limit: this.props.customerSubscriptionPlan.seats_limit,
          threat_ranking_profile_limit: this.props.customerSubscriptionPlan
            .threat_ranking_profile_limit,
          requests_limit: this.props.customerSubscriptionPlan.requests_limit,
          live_brand_limit: this.props.customerSubscriptionPlan
            .live_brand_limit,
          has_access_to_threat_ranking: this.props.customerSubscriptionPlan
            .has_access_to_threat_ranking,
          has_access_to_advanced_filter: this.props.customerSubscriptionPlan
            .has_access_to_advanced_filter,
          has_access_to_sources: this.props.customerSubscriptionPlan
            .has_access_to_sources,
          has_access_to_copy_end_point: this.props.customerSubscriptionPlan
            .has_access_to_copy_end_point,
          has_access_to_monitoring: this.props.customerSubscriptionPlan
            .has_access_to_monitoring,
          has_access_to_query_history: this.props.customerSubscriptionPlan
            .has_access_to_query_history,
          has_access_to_web_scanner: this.props.customerSubscriptionPlan
            .has_access_to_web_scanner,
          has_access_to_brand_impersonation_recipe: this.props
            .customerSubscriptionPlan?.has_access_to_brand_impersonation_recipe,
          has_access_to_dangling_dns_detection_recipe: this.props
            .customerSubscriptionPlan
            ?.has_access_to_dangling_dns_detection_recipe,
          has_access_to_dangling_dns_records_count_recipe: this.props
            .customerSubscriptionPlan
            ?.has_access_to_dangling_dns_records_count_recipe,
          has_access_to_discover_shadow_it_recipe: this.props
            .customerSubscriptionPlan?.has_access_to_discover_shadow_it_recipe,
          has_access_to_domain_name_server_changes_recipe: this.props
            .customerSubscriptionPlan
            ?.has_access_to_domain_name_server_changes_recipe,
          has_access_to_domain_txt_records_recipe: this.props
            .customerSubscriptionPlan?.has_access_to_domain_txt_records_recipe,
          has_access_to_domains_hosted_on_ip_recipe: this.props
            .customerSubscriptionPlan
            ?.has_access_to_domains_hosted_on_ip_recipe,
          has_access_to_domains_hosted_on_server_recipe: this.props
            .customerSubscriptionPlan
            ?.has_access_to_domains_hosted_on_server_recipe,
          has_access_to_hosting_infra_asns_recipe: this.props
            .customerSubscriptionPlan?.has_access_to_hosting_infra_asns_recipe,
          has_access_to_hosting_infra_ips_recipe: this.props
            .customerSubscriptionPlan?.has_access_to_hosting_infra_ips_recipe,
          has_access_to_ip_diversity_of_domain_recipe: this.props
            .customerSubscriptionPlan
            ?.has_access_to_ip_diversity_of_domain_recipe,
          has_access_to_ips_hosting_a_domain_recipe: this.props
            .customerSubscriptionPlan
            ?.has_access_to_ips_hosting_a_domain_recipe,
          has_access_to_latest_dns_records_recipe: this.props
            .customerSubscriptionPlan?.has_access_to_latest_dns_records_recipe,
          has_access_to_subdomain_finder_recipe: this.props
            .customerSubscriptionPlan?.has_access_to_subdomain_finder_recipe,
          has_access_to_name_in_txt_recipe: this.props.customerSubscriptionPlan
            ?.has_access_to_name_in_txt_recipe,

          has_access_to_enrich: this.props.customerSubscriptionPlan
            .has_access_to_enrich,
          has_access_to_query_builder: this.props.customerSubscriptionPlan
            .has_access_to_query_builder,
          has_access_to_preferences: this.props.customerSubscriptionPlan
            .has_access_to_preferences,
          has_access_to_org_settings: this.props.customerSubscriptionPlan
            .has_access_to_org_settings,
          has_access_to_subscription_page: this.props.customerSubscriptionPlan
            .has_access_to_subscription_page,
          has_access_to_share_unshare: this.props.customerSubscriptionPlan
            .has_access_to_share_unshare,
          has_access_to_explore: this.props.customerSubscriptionPlan
            .has_access_to_explore,
          has_limited_access_to_query_builder: this.props
            .customerSubscriptionPlan.has_limited_access_to_query_builder,
          has_access_to_data_marketplace: this.props.customerSubscriptionPlan
            .has_access_to_data_marketplace,
          has_access_to_tlp_amber_report: this.props.customerSubscriptionPlan
            .has_access_to_tlp_amber_report,
          has_access_to_bulk_data_feeds: this.props.customerSubscriptionPlan
            .has_access_to_bulk_data_feeds, //remove after transition
        });
      }
    }

    if (
      prevProps.customerOrganizationSubscription !==
        this.props.customerOrganizationSubscription &&
      this.props.customerOrganizationSubscriptionStatus === STATUS.LOADED
    ) {
      this.setState({
        currentCustomer: {
          ...this.state.currentCustomer,
          subscription: this.props.customerOrganizationSubscription,
        },
      });
    }

    if (
      this.state.action === 'add' &&
      this.props.customerOrganizationsCreationStatus === STATUS.LOADED
    ) {
      //this section is for saving a newly created organisation
      const {
        currentlySelectedMarketplaceDataFeedDownloadOptions,
        currentlySelectedMarketplaceDataFeedVisibilityOptions,
      } = this.state;

      const downloadOptions = currentlySelectedMarketplaceDataFeedDownloadOptions.map(
        (feed) => {
          return feed.value;
        },
      );
      const visibilityOptions = currentlySelectedMarketplaceDataFeedVisibilityOptions.map(
        (feed) => {
          return feed.value;
        },
      );

      const subscriptionValues = {
        uuid: this.props.customerOrganizationsCreationData?.uuid,
        plan: this.state.selectedPlan,
        data_market_feeds: downloadOptions?.join(),
        data_market_feeds_visible: visibilityOptions?.join(),
        live_brand_limit: this.state.permissionFormValues?.live_brand_limit,
        organisation: this.props.customerOrganizationsCreationData?.id,
        requests_limit: this.state.permissionFormValues?.requests_limit,
        seats_limit: this.state.permissionFormValues?.seats_limit,
        threat_ranking_profile_limit: this.state.permissionFormValues
          ?.threat_ranking_profile_limit,
        expiration_date: this.state.permissionFormValues?.expiration_date
          ? moment(this.state.permissionFormValues?.expiration_date).format(
              'YYYY-MM-DD',
            )
          : undefined,
        has_access_to_threat_ranking: this.state.permissionFormValues
          ?.has_access_to_threat_ranking,
        has_access_to_advanced_filter: this.state.permissionFormValues
          ?.has_access_to_advanced_filter,
        has_access_to_sources: this.state.permissionFormValues
          ?.has_access_to_sources,
        has_access_to_copy_end_point: this.state.permissionFormValues
          ?.has_access_to_copy_end_point,
        has_access_to_monitoring: this.state.permissionFormValues
          ?.has_access_to_monitoring,
        has_access_to_query_history: this.state.permissionFormValues
          ?.has_access_to_query_history,
        has_access_to_web_scanner: this.state.permissionFormValues
          ?.has_access_to_web_scanner,
        has_access_to_brand_impersonation_recipe: this.state
          .permissionFormValues?.has_access_to_brand_impersonation_recipe,
        has_access_to_dangling_dns_detection_recipe: this.state
          .permissionFormValues?.has_access_to_dangling_dns_detection_recipe,
        has_access_to_dangling_dns_records_count_recipe: this.state
          .permissionFormValues
          ?.has_access_to_dangling_dns_records_count_recipe,
        has_access_to_discover_shadow_it_recipe: this.state.permissionFormValues
          ?.has_access_to_discover_shadow_it_recipe,
        has_access_to_domain_name_server_changes_recipe: this.state
          .permissionFormValues
          ?.has_access_to_domain_name_server_changes_recipe,
        has_access_to_domain_txt_records_recipe: this.state.permissionFormValues
          ?.has_access_to_domain_txt_records_recipe,
        has_access_to_domains_hosted_on_ip_recipe: this.state
          .permissionFormValues?.has_access_to_domains_hosted_on_ip_recipe,
        has_access_to_domains_hosted_on_server_recipe: this.state
          .permissionFormValues?.has_access_to_domains_hosted_on_server_recipe,
        has_access_to_hosting_infra_asns_recipe: this.state.permissionFormValues
          ?.has_access_to_hosting_infra_asns_recipe,
        has_access_to_hosting_infra_ips_recipe: this.state.permissionFormValues
          ?.has_access_to_hosting_infra_ips_recipe,
        has_access_to_ip_diversity_of_domain_recipe: this.state
          .permissionFormValues?.has_access_to_ip_diversity_of_domain_recipe,
        has_access_to_ips_hosting_a_domain_recipe: this.state
          .permissionFormValues?.has_access_to_ips_hosting_a_domain_recipe,
        has_access_to_latest_dns_records_recipe: this.state.permissionFormValues
          ?.has_access_to_latest_dns_records_recipe,
        has_access_to_subdomain_finder_recipe: this.state.permissionFormValues
          ?.has_access_to_subdomain_finder_recipe,
        has_access_to_name_in_txt_recipe: this.state.permissionFormValues
          ?.has_access_to_name_in_txt_recipe,

        has_access_to_enrich: this.state.permissionFormValues
          ?.has_access_to_enrich,
        has_access_to_query_builder: this.state.permissionFormValues
          ?.has_access_to_query_builder,
        has_access_to_preferences: this.state.permissionFormValues
          ?.has_access_to_preferences,
        has_access_to_org_settings: this.state.permissionFormValues
          ?.has_access_to_org_settings,
        has_access_to_subscription_page: this.state.permissionFormValues
          ?.has_access_to_subscription_page,
        has_access_to_share_unshare: this.state.permissionFormValues
          ?.has_access_to_share_unshare,
        has_access_to_explore: this.state.permissionFormValues
          ?.has_access_to_explore,
        has_limited_access_to_query_builder: this.state.permissionFormValues
          ?.has_limited_access_to_query_builder,
        has_access_to_data_marketplace: this.state.permissionFormValues
          ?.has_access_to_data_marketplace,
        has_access_to_tlp_amber_report: this.state.permissionFormValues
          ?.has_access_to_tlp_amber_report,
        has_access_to_bulk_data_feeds: this.props.permissionFormValues
          ?.has_access_to_bulk_data_feeds, //remove after transition
      };

      this.props.createCustomerSubscription(subscriptionValues);
      this.props.resetCreateOrganizationStatus();
      this.handleBackClick();
    }

    if (this.state.action === 'editSubscription') {
      //bulk data feed logic - remove after transition
      if (
        currentSelectedBulkDataFeeds !==
        this.state.currentCustomerSubscription?.bulk_data_feeds
      ) {
        this.setState({
          currentSelectedBulkDataFeeds: this.state.currentCustomerSubscription
            ?.bulk_data_feeds,
        });

        if (
          this.state.currentCustomerSubscription?.bulk_data_feeds?.length > 0
        ) {
          const options = this.state.currentCustomerSubscription.bulk_data_feeds.map(
            (feed) => {
              return { label: feed.feed_name, value: feed.uuid };
            },
          );

          this.setState({ currentSelectedBulkDataFeedsOptions: options });
        } else {
          this.setState({ currentSelectedBulkDataFeedsOptions: [] });
        }
      }

      let downloadOptions = [];
      let visibilityOptions = [];

      if (initialLoad) {
        //pre set options when editing a subscription

        if (
          this.state.currentCustomerSubscription?.data_market_feeds?.length > 0
        ) {
          downloadOptions = this.state.currentCustomerSubscription.data_market_feeds.map(
            (feed) => {
              return {
                label: feed.category + ': ' + feed.feed_name,
                value: feed.uuid,
              };
            },
          );
        }

        if (
          this.state.currentCustomerSubscription?.data_market_feeds_visible
            ?.length > 0
        ) {
          visibilityOptions = this.state.currentCustomerSubscription.data_market_feeds_visible.map(
            (feed) => {
              return {
                label: feed.category + ': ' + feed.feed_name,
                value: feed.uuid,
              };
            },
          );
        }

        //pre set download options when editing subscritions
        if (
          currentlySelectedMarketplaceDataFeedDownloadOptions.toString() !==
          downloadOptions.toString()
        ) {
          this.setState({
            currentlySelectedMarketplaceDataFeedDownloadOptions: downloadOptions,
          });

          if (
            this.state.currentCustomerSubscription?.data_market_feeds?.length >
            0
          ) {
            this.setState({
              currentSelectedBulkDataFeedsOptions: downloadOptions,
            });
          } else {
            this.setState({ currentSelectedBulkDataFeedsOptions: [] });
          }
        }

        //pre set visibility options when editing subscritions
        if (
          currentlySelectedMarketplaceDataFeedVisibilityOptions.toString() !==
          visibilityOptions.toString()
        ) {
          this.setState({
            currentlySelectedMarketplaceDataFeedVisibilityOptions: visibilityOptions,
          });

          if (
            this.state.currentCustomerSubscription?.data_market_feeds_visible
              ?.length > 0
          ) {
            this.setState({
              currentlySelectedMarketplaceDataFeedVisibilityOptions: visibilityOptions,
            });
          } else {
            this.setState({
              currentlySelectedMarketplaceDataFeedVisibilityOptions: [],
            });
          }
        }

        this.setState({ initialLoad: false });
      }
    }

    if (this.state.action === 'add') {
      //this section is for adding a new a subscription
      if (selectedPlan === '3e25b016-112d-4d25-8876-b774eab1aaa1') {
        //if the selected plan is enterprise pre-select all marketplace data feed options
        this.setState({
          currentlySelectedMarketplaceDataFeedDownloadOptions: this.props
            .dataMarketplaceFeedOptions,
          currentlySelectedMarketplaceDataFeedVisibilityOptions: this.props
            .dataMarketplaceFeedOptions,
        });
      } else {
        if (
          this.state.currentlySelectedMarketplaceDataFeedDownloadOptions
            ?.length > 0
        ) {
          this.setState({
            currentlySelectedMarketplaceDataFeedDownloadOptions: [],
          });
        }
        if (
          this.state.currentlySelectedMarketplaceDataFeedVisibilityOptions
            ?.length > 0
        ) {
          this.setState({
            currentlySelectedMarketplaceDataFeedVisibilityOptions: [],
          });
        }
      }
    }

    if (this.props.setOrganizationInactiveStatus === STATUS.LOADED) {
      this.props.loadCustomerOrganizationsList();
      this.props.resetSetOrganizationInactiveStatus();
    }
    if (this.props.setOrganizationActiveStatus === STATUS.LOADED) {
      this.props.loadCustomerOrganizationsList();
      this.props.resetSetOrganizationActiveStatus();
    }
  }

  handleCancel = () => {
    this.props.resetCreateOrganizationStatus();
    this.setState({ action: 'list' });
    this.setState({ currentCustomer: null });
    this.setState({ initialLoad: true });
    this.props.loadCustomerOrganizationsList();
  };

  handleAddClick = () => {
    this.props.resetCreateOrganizationStatus();
    this.setState({ action: 'add' });
    this.setState({ currentCustomer: null });
    this.setState({ selectedPlan: null });
    this.props.loadCustomerOrganizationsList();
  };

  handleEditClick = (currentCustomer) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.props.resetCreateOrganizationStatus();
    this.setState({ action: 'edit' });
    this.setState({ currentCustomer });
    this.props.loadCustomerOrganizationsList();
  };

  handleBackClick = () => {
    this.setState({ action: 'list' });
    this.setState({ currentCustomer: null });
    this.setState({ currentCustomerSubscription: null });
    this.setState({ communityCustomer: false });
    this.props.loadCustomerOrganizationsListPage(
      this.state.currentPage ? this.state.currentPage : 1,
      this.state.searchText ? this.state.searchText : '',
    );
  };

  handleOrganizationSubmit = async (values) => {
    const {
      currentCustomer,
      currentlySelectedMarketplaceDataFeedDownloadOptions,
      currentlySelectedMarketplaceDataFeedVisibilityOptions,
    } = this.state;
    let downloadPermissionFeeds = currentlySelectedMarketplaceDataFeedDownloadOptions;
    let visibilityPermissionFeeds = currentlySelectedMarketplaceDataFeedVisibilityOptions;

    const organizationValues = {
      ...(this.state.action === 'edit' && { uuid: currentCustomer?.uuid }),
      uuid: currentCustomer?.uuid,
      company_name: values?.company_name,
      country: values?.country,
      city: values?.city,
      address: values?.address,
      email: values?.email,
      phone: values?.phone,
    };

    if (currentlySelectedMarketplaceDataFeedDownloadOptions?.length > 0) {
      downloadPermissionFeeds = currentlySelectedMarketplaceDataFeedDownloadOptions.map(
        (feed) => {
          if (typeof feed === 'object') {
            return feed.value;
          } else {
            return feed;
          }
        },
      );
    }
    if (currentlySelectedMarketplaceDataFeedVisibilityOptions?.length > 0) {
      visibilityPermissionFeeds = currentlySelectedMarketplaceDataFeedVisibilityOptions.map(
        (feed) => {
          if (typeof feed === 'object') {
            return feed.value;
          } else {
            return feed;
          }
        },
      );
    }

    const subscriptionValues = {
      uuid: currentCustomer?.subscription?.uuid,
      plan: this.state.selectedPlan,
      data_market_feeds: downloadPermissionFeeds?.join(),
      data_market_feeds_visible: visibilityPermissionFeeds?.join(),
      live_brand_limit: values?.live_brand_limit,
      organisation: values?.organisation || this.state.currentCustomer?.id,
      requests_limit: values?.requests_limit,
      seats_limit: values?.seats_limit,
      threat_ranking_profile_limit: values?.threat_ranking_profile_limit,
      expiration_date: values.expiration_date
        ? moment(values.expiration_date).format('YYYY-MM-DD')
        : undefined,
      has_access_to_threat_ranking: values?.has_access_to_threat_ranking,
      has_access_to_advanced_filter: values?.has_access_to_advanced_filter,
      has_access_to_sources: values?.has_access_to_sources,
      has_access_to_copy_end_point: values?.has_access_to_copy_end_point,
      has_access_to_monitoring: values?.has_access_to_monitoring,
      has_access_to_query_history: values?.has_access_to_query_history,
      has_access_to_web_scanner: values?.has_access_to_web_scanner,
      has_access_to_brand_impersonation_recipe:
        values?.has_access_to_brand_impersonation_recipe,
      has_access_to_dangling_dns_detection_recipe:
        values?.has_access_to_dangling_dns_detection_recipe,
      has_access_to_dangling_dns_records_count_recipe:
        values?.has_access_to_dangling_dns_records_count_recipe,
      has_access_to_discover_shadow_it_recipe:
        values?.has_access_to_discover_shadow_it_recipe,
      has_access_to_domain_name_server_changes_recipe:
        values?.has_access_to_domain_name_server_changes_recipe,
      has_access_to_domain_txt_records_recipe:
        values?.has_access_to_domain_txt_records_recipe,
      has_access_to_domains_hosted_on_ip_recipe:
        values?.has_access_to_domains_hosted_on_ip_recipe,
      has_access_to_domains_hosted_on_server_recipe:
        values?.has_access_to_domains_hosted_on_server_recipe,
      has_access_to_hosting_infra_asns_recipe:
        values?.has_access_to_hosting_infra_asns_recipe,
      has_access_to_hosting_infra_ips_recipe:
        values?.has_access_to_hosting_infra_ips_recipe,
      has_access_to_ip_diversity_of_domain_recipe:
        values?.has_access_to_ip_diversity_of_domain_recipe,
      has_access_to_ips_hosting_a_domain_recipe:
        values?.has_access_to_ips_hosting_a_domain_recipe,
      has_access_to_latest_dns_records_recipe:
        values?.has_access_to_latest_dns_records_recipe,
      has_access_to_subdomain_finder_recipe:
        values?.has_access_to_subdomain_finder_recipe,
      has_access_to_name_in_txt_recipe:
        values?.has_access_to_name_in_txt_recipe,

      has_access_to_enrich: values?.has_access_to_enrich,
      has_access_to_query_builder: values?.has_limited_access_to_query_builder
        ? true
        : values?.has_access_to_query_builder,
      has_access_to_preferences: values?.has_access_to_preferences,
      has_access_to_org_settings: values?.has_access_to_org_settings,
      has_access_to_subscription_page: values?.has_access_to_subscription_page,
      has_access_to_share_unshare: values?.has_access_to_share_unshare,
      has_access_to_explore: values?.has_access_to_explore,
      has_limited_access_to_query_builder:
        values?.has_limited_access_to_query_builder,
      has_access_to_data_marketplace: values?.has_access_to_data_marketplace,
      has_access_to_tlp_amber_report: values?.has_access_to_tlp_amber_report,
      has_access_to_bulk_data_feeds: values?.has_access_to_bulk_data_feeds, //remove after transition
    };

    if (this.state.action === 'edit') {
      this.props.updateCustomerOrganization(organizationValues);
      setTimeout(() => {
        this.handleBackClick();
      }, 1500);
    } else if (this.state.action === 'add') {
      this.setState({ permissionFormValues: subscriptionValues });
      await this.props.createCustomerOrganization(organizationValues);
    }
    window.scrollTo(0, 0);
  };

  handleSubscriptionSubmit = (values) => {
    const {
      currentlySelectedMarketplaceDataFeedDownloadOptions,
      currentlySelectedMarketplaceDataFeedVisibilityOptions,
    } = this.state;
    let downloadPermissionFeeds = currentlySelectedMarketplaceDataFeedDownloadOptions;
    let visibilityPermissionFeeds = currentlySelectedMarketplaceDataFeedVisibilityOptions;

    if (currentlySelectedMarketplaceDataFeedDownloadOptions?.length > 0) {
      downloadPermissionFeeds = currentlySelectedMarketplaceDataFeedDownloadOptions.map(
        (feed) => {
          if (typeof feed === 'object') {
            return feed.value;
          } else {
            return feed;
          }
        },
      );
    }
    if (currentlySelectedMarketplaceDataFeedVisibilityOptions?.length > 0) {
      visibilityPermissionFeeds = currentlySelectedMarketplaceDataFeedVisibilityOptions.map(
        (feed) => {
          if (typeof feed === 'object') {
            return feed.value;
          } else {
            return feed;
          }
        },
      );
    }

    const subscriptionValues = {
      uuid: values.uuid,
      plan: this.state.selectedPlan,
      data_market_feeds: downloadPermissionFeeds?.join(),
      data_market_feeds_visible: visibilityPermissionFeeds?.join(),
      live_brand_limit: values?.live_brand_limit,
      organisation: values?.organisation || this.state.currentCustomer.id,
      requests_limit: values?.requests_limit,
      seats_limit: values?.seats_limit,
      threat_ranking_profile_limit: values?.threat_ranking_profile_limit,
      expiration_date: values.expiration_date
        ? moment(values.expiration_date).format('YYYY-MM-DD')
        : undefined,
      has_access_to_threat_ranking: values?.has_access_to_threat_ranking,
      has_access_to_advanced_filter: values?.has_access_to_advanced_filter,
      has_access_to_sources: values?.has_access_to_sources,
      has_access_to_copy_end_point: values?.has_access_to_copy_end_point,
      has_access_to_monitoring: values?.has_access_to_monitoring,
      has_access_to_query_history: values?.has_access_to_query_history,
      has_access_to_web_scanner: values?.has_access_to_web_scanner,
      has_access_to_brand_impersonation_recipe:
        values?.has_access_to_brand_impersonation_recipe,
      has_access_to_dangling_dns_detection_recipe:
        values?.has_access_to_dangling_dns_detection_recipe,
      has_access_to_dangling_dns_records_count_recipe:
        values?.has_access_to_dangling_dns_records_count_recipe,
      has_access_to_discover_shadow_it_recipe:
        values?.has_access_to_discover_shadow_it_recipe,
      has_access_to_domain_name_server_changes_recipe:
        values?.has_access_to_domain_name_server_changes_recipe,
      has_access_to_domain_txt_records_recipe:
        values?.has_access_to_domain_txt_records_recipe,
      has_access_to_domains_hosted_on_ip_recipe:
        values?.has_access_to_domains_hosted_on_ip_recipe,
      has_access_to_domains_hosted_on_server_recipe:
        values?.has_access_to_domains_hosted_on_server_recipe,
      has_access_to_hosting_infra_asns_recipe:
        values?.has_access_to_hosting_infra_asns_recipe,
      has_access_to_hosting_infra_ips_recipe:
        values?.has_access_to_hosting_infra_ips_recipe,
      has_access_to_ip_diversity_of_domain_recipe:
        values?.has_access_to_ip_diversity_of_domain_recipe,
      has_access_to_ips_hosting_a_domain_recipe:
        values?.has_access_to_ips_hosting_a_domain_recipe,
      has_access_to_latest_dns_records_recipe:
        values?.has_access_to_latest_dns_records_recipe,
      has_access_to_subdomain_finder_recipe:
        values?.has_access_to_subdomain_finder_recipe,
      has_access_to_name_in_txt_recipe:
        values?.has_access_to_name_in_txt_recipe,

      has_access_to_enrich: values?.has_access_to_enrich,
      has_access_to_query_builder: values?.has_limited_access_to_query_builder
        ? true
        : values?.has_access_to_query_builder,
      has_access_to_preferences: values?.has_access_to_preferences,
      has_access_to_org_settings: values?.has_access_to_org_settings,
      has_access_to_subscription_page: values?.has_access_to_subscription_page,
      has_access_to_share_unshare: values?.has_access_to_share_unshare,
      has_access_to_explore: values?.has_access_to_explore,
      has_limited_access_to_query_builder:
        values?.has_limited_access_to_query_builder,
      has_access_to_data_marketplace: values?.has_access_to_data_marketplace,
      has_access_to_tlp_amber_report: values?.has_access_to_tlp_amber_report,
      has_access_to_bulk_data_feeds: values?.has_access_to_bulk_data_feeds, //remove after transition
    };
    if (this.state.currentCustomerSubscription) {
      this.props.updateCustomerSubscription(subscriptionValues);
      setTimeout(() => {
        this.handleBackClick();
      }, 1000);
    } else {
      this.props.createCustomerSubscription(subscriptionValues);
    }
    this.setState({ initialLoad: true });
    window.scrollTo(0, 0);
  };

  handlePermissionChange = (changedValue, allValues) => {
    if (changedValue?.email) {
      this.formRef.current.setFieldsValue({
        email: formatEmail(changedValue.email),
      });
    }

    //threat management section
    if (changedValue.has_access_to_threat_ranking === false) {
      this.formRef.current.setFieldsValue({
        has_access_to_sources: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_advanced_filter: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_copy_end_point: false,
      });
    }

    if (changedValue.has_access_to_sources === false) {
      this.formRef.current.setFieldsValue({
        has_access_to_threat_ranking: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_advanced_filter: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_copy_end_point: false,
      });
    }

    if (changedValue.has_access_to_advanced_filter === false) {
      this.formRef.current.setFieldsValue({
        has_access_to_threat_ranking: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_sources: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_copy_end_point: false,
      });
    }

    if (changedValue.has_access_to_copy_end_point === false) {
      this.formRef.current.setFieldsValue({
        has_access_to_threat_ranking: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_sources: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_advanced_filter: false,
      });
    }

    if (changedValue.has_access_to_threat_ranking === true) {
      this.formRef.current.setFieldsValue({
        has_access_to_sources: true,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_advanced_filter: true,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_copy_end_point: true,
      });
    }

    if (changedValue.has_access_to_sources === true) {
      this.formRef.current.setFieldsValue({
        has_access_to_threat_ranking: true,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_advanced_filter: true,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_copy_end_point: true,
      });
    }

    if (changedValue.has_access_to_advanced_filter === true) {
      this.formRef.current.setFieldsValue({
        has_access_to_threat_ranking: true,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_sources: true,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_copy_end_point: true,
      });
    }

    if (changedValue.has_access_to_copy_end_point === true) {
      this.formRef.current.setFieldsValue({
        has_access_to_threat_ranking: true,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_sources: true,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_advanced_filter: true,
      });
    }

    //"explore" section
    if (changedValue.has_access_to_explore === false) {
      this.formRef.current.setFieldsValue({
        has_access_to_monitoring: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_query_builder: false,
      });
      this.formRef.current.setFieldsValue({
        has_limited_access_to_query_builder: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_enrich: false,
      });
    }

    if (changedValue.has_access_to_query_builder === false) {
      this.formRef.current.setFieldsValue({
        has_access_to_explore: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_monitoring: false,
      });
      this.formRef.current.setFieldsValue({
        has_limited_access_to_query_builder: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_enrich: false,
      });
    }

    if (changedValue.has_limited_access_to_query_builder === false) {
      this.formRef.current.setFieldsValue({
        has_access_to_explore: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_query_builder: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_enrich: false,
      });
    }

    if (changedValue.has_access_to_enrich === false) {
      this.formRef.current.setFieldsValue({
        has_access_to_explore: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_monitoring: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_query_builder: false,
      });
      this.formRef.current.setFieldsValue({
        has_limited_access_to_query_builder: false,
      });
    }

    if (changedValue.has_access_to_explore === true) {
      this.formRef.current.setFieldsValue({
        has_access_to_query_builder: true,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_enrich: true,
      });
    }

    if (changedValue.has_access_to_query_builder === true) {
      this.formRef.current.setFieldsValue({
        has_access_to_explore: true,
      });
      this.formRef.current.setFieldsValue({
        has_limited_access_to_query_builder: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_enrich: true,
      });
    }

    if (changedValue.has_limited_access_to_query_builder === true) {
      this.formRef.current.setFieldsValue({
        has_access_to_explore: true,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_query_builder: false,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_enrich: true,
      });
    }

    if (changedValue.has_access_to_enrich === true) {
      this.formRef.current.setFieldsValue({
        has_access_to_explore: true,
      });
      this.formRef.current.setFieldsValue({
        has_access_to_query_builder: true,
      });
    }
  };

  handleDeleteClick = (currentCustomer) => {
    this.setState({ action: 'delete' });
    confirmDelete({
      onOk: () => {
        this.props.deleteCustomerOrganization(currentCustomer.uuid);
      },
    });
  };

  handleEditSubscriptionClick = (currentCustomer) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.setState({ action: 'editSubscription' });
    this.setState({
      currentCustomerSubscription: currentCustomer?.subscription,
    });
    this.setState({ currentCustomer: currentCustomer });
    this.setState({ selectedPlan: currentCustomer?.subscription?.plan_uuid });
    this.setState({ initialLoad: true });
  };

  handleNotifySubscriptionRestrictedClick = (currentCustomer) => {
    this.props.notifySubscriptionRestrictedCustomerOrganization(
      currentCustomer?.id,
    );
  };

  handleSetOrganizationInactive = (currentCustomer) => {
    this.props.setOrganizationInactive(currentCustomer.uuid);
  };

  handleSetOrganizationActive = async () => {
    this.setState({ activateOrgLoading: true });
    try {
      await this.props.setOrganizationActive(
        this.state.currentSelectedOrganization.uuid,
        this.state.activateOrgExpirationDate,
      );

      this.setState({ activateOrgModal: false });
      this.setState({ activateOrgLoading: false });
      this.setState({ currentSelectedOrganization: [] });
    } catch (e) {}
  };

  handleOrgModalDatePickerChange = (date, dateString) => {
    this.setState({ activateOrgExpirationDate: dateString });
  };

  handleDownloadMarketplaceDataFeedsSelectChange = (value) => {
    this.setState({
      currentlySelectedMarketplaceDataFeedDownloadOptions: value,
    });
  };
  handleVisibleMarketplaceDataFeedsSelectChange = (value) => {
    this.setState({
      currentlySelectedMarketplaceDataFeedVisibilityOptions: value,
    });
  };

  handleSelectAllDownloadMarketplaceDataFeeds = () => {
    this.setState({
      currentlySelectedMarketplaceDataFeedDownloadOptions: this.props
        .dataMarketplaceFeedOptions,
    });
  };
  handleSelectAllVisibleMarketplaceDataFeeds = () => {
    this.setState({
      currentlySelectedMarketplaceDataFeedVisibilityOptions: this.props
        .dataMarketplaceFeedOptions,
    });
  };

  renderPlanView = () => {
    return (
      <Row gutter={24}>
        <Col xs={24} lg={12}>
          <Form.Item
            shouldUpdate
            name={'plan'}
            label="Plan"
            rules={[{ required: true, message: 'Please select a plan!' }]}
          >
            <Select
              onChange={(value) => {
                this.setState({ selectedPlan: value });
                this.props.loadCustomerSubscriptionPlan(value);
              }}
              placeholder="Select a Plan"
            >
              <Select.Option value={'3e25b016-112d-4d25-8876-b774eab1aaa1'}>
                Enterprise
              </Select.Option>
              <Select.Option value={'3e25b016-112d-4d25-8876-b774eab1aaa2'}>
                Professional
              </Select.Option>
              <Select.Option value={'3e25b016-112d-4d25-8876-b774eab1aaa3'}>
                Community
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name={'seats_limit'} label="Seats Limit">
            <Input disabled={this.state.action == 'add'} />
          </Form.Item>
          <Form.Item
            name={'threat_ranking_profile_limit'}
            label="Filter Profile Limit"
          >
            <Input disabled={this.state.action == 'add'} />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item
            label="Expiration Date"
            name={'expiration_date'}
            rules={[
              {
                required: this.state.action === 'add' ? true : false,
                message: 'Please select an expiration date!',
              },
            ]}
          >
            <DatePicker
              disabledDate={(date) => {
                return date.isBefore(moment());
              }}
              format="YYYY-MM-DD"
            />
          </Form.Item>
          <Form.Item name={'requests_limit'} label="Requests Limit">
            <Input disabled={this.state.action == 'add'} />
          </Form.Item>
          <Form.Item name={'live_brand_limit'} label="Brand Limit">
            <Input disabled={this.state.action == 'add'} />
          </Form.Item>
        </Col>
      </Row>
    );
  };

  renderSubscriptionForm = () => {
    const {
      currentSelectedBulkDataFeedsOptions, //remove after transition
      bulkDataFeedOptions, //remove after transition
      bulkDataFeedOptionsStatus, //remove after transition

      currentCustomerSubscription,
      currentlySelectedMarketplaceDataFeedDownloadOptions,
      currentlySelectedMarketplaceDataFeedVisibilityOptions,
    } = this.state;
    const {
      dataMarketplaceFeedOptionsStatus,
      dataMarketplaceFeedOptions,
    } = this.props;

    return (
      <Form
        name="subscription"
        autoComplete="off"
        initialValues={{
          id: currentCustomerSubscription?.id,
          uuid: currentCustomerSubscription?.uuid,
          organisation: currentCustomerSubscription?.organisation,
          plan: this.state.selectedPlan,
          seats_limit: currentCustomerSubscription?.seats_limit,
          threat_ranking_profile_limit:
            currentCustomerSubscription?.threat_ranking_profile_limit,
          requests_limit: currentCustomerSubscription?.requests_limit,
          live_brand_limit: currentCustomerSubscription?.live_brand_limit,
          expiration_date: moment(currentCustomerSubscription?.expiration_date),
          has_access_to_threat_ranking:
            currentCustomerSubscription?.has_access_to_threat_ranking,
          has_access_to_advanced_filter:
            currentCustomerSubscription?.has_access_to_advanced_filter,
          has_access_to_sources:
            currentCustomerSubscription?.has_access_to_sources,
          has_access_to_copy_end_point:
            currentCustomerSubscription?.has_access_to_copy_end_point,
          has_access_to_monitoring:
            currentCustomerSubscription?.has_access_to_monitoring,
          has_access_to_query_history:
            currentCustomerSubscription?.has_access_to_query_history,
          has_access_to_web_scanner:
            currentCustomerSubscription?.has_access_to_web_scanner,
          has_access_to_brand_impersonation_recipe:
            currentCustomerSubscription?.has_access_to_brand_impersonation_recipe,
          has_access_to_dangling_dns_detection_recipe:
            currentCustomerSubscription?.has_access_to_dangling_dns_detection_recipe,
          has_access_to_dangling_dns_records_count_recipe:
            currentCustomerSubscription?.has_access_to_dangling_dns_records_count_recipe,
          has_access_to_discover_shadow_it_recipe:
            currentCustomerSubscription?.has_access_to_discover_shadow_it_recipe,
          has_access_to_domain_name_server_changes_recipe:
            currentCustomerSubscription?.has_access_to_domain_name_server_changes_recipe,
          has_access_to_domain_txt_records_recipe:
            currentCustomerSubscription?.has_access_to_domain_txt_records_recipe,
          has_access_to_domains_hosted_on_ip_recipe:
            currentCustomerSubscription?.has_access_to_domains_hosted_on_ip_recipe,
          has_access_to_domains_hosted_on_server_recipe:
            currentCustomerSubscription?.has_access_to_domains_hosted_on_server_recipe,
          has_access_to_hosting_infra_asns_recipe:
            currentCustomerSubscription?.has_access_to_hosting_infra_asns_recipe,
          has_access_to_hosting_infra_ips_recipe:
            currentCustomerSubscription?.has_access_to_hosting_infra_ips_recipe,
          has_access_to_ip_diversity_of_domain_recipe:
            currentCustomerSubscription?.has_access_to_ip_diversity_of_domain_recipe,
          has_access_to_ips_hosting_a_domain_recipe:
            currentCustomerSubscription?.has_access_to_ips_hosting_a_domain_recipe,
          has_access_to_latest_dns_records_recipe:
            currentCustomerSubscription?.has_access_to_latest_dns_records_recipe,
          has_access_to_subdomain_finder_recipe:
            currentCustomerSubscription?.has_access_to_subdomain_finder_recipe,
          has_access_to_name_in_txt_recipe:
            currentCustomerSubscription?.has_access_to_name_in_txt_recipe,

          has_access_to_enrich:
            currentCustomerSubscription?.has_access_to_enrich,
          has_access_to_query_builder: currentCustomerSubscription?.has_limited_access_to_query_builder
            ? false
            : currentCustomerSubscription?.has_access_to_query_builder,
          has_access_to_preferences:
            currentCustomerSubscription?.has_access_to_preferences,
          has_access_to_org_settings:
            currentCustomerSubscription?.has_access_to_org_settings,
          has_access_to_subscription_page:
            currentCustomerSubscription?.has_access_to_subscription_page,
          has_access_to_share_unshare:
            currentCustomerSubscription?.has_access_to_share_unshare,
          has_access_to_explore:
            currentCustomerSubscription?.has_access_to_explore,
          has_limited_access_to_query_builder:
            currentCustomerSubscription?.has_limited_access_to_query_builder,
          has_access_to_data_marketplace:
            currentCustomerSubscription?.has_access_to_data_marketplace,
          has_access_to_tlp_amber_report:
            currentCustomerSubscription?.has_access_to_tlp_amber_report,
          has_access_to_bulk_data_feeds:
            currentCustomerSubscription?.has_access_to_bulk_data_feeds, //remove after transition
        }}
        layout={'vertical'}
        className={styles.organization_form}
        onFinish={this.handleSubscriptionSubmit}
        onValuesChange={this.handlePermissionChange}
        ref={this.formRef}
      >
        <Panel bgcolor={'#1C3138'}>
          <Title level={3}>Edit Subscription</Title>
          {this.renderPlanView()}

          <Row gutter={24} className={'mt-1'}>
            <Col xs={24}>
              <Title level={4}>Permission level control:</Title>
              <div className={styles.flag_container}>
                <Form.Item name="has_access_to_explore" valuePropName="checked">
                  <Checkbox
                    data-testid="has_access_to_explore"
                    disabled={this.state.exploreAccessDisabled}
                  >
                    Explore access
                  </Checkbox>
                </Form.Item>
                <Form.Item name="has_access_to_enrich" valuePropName="checked">
                  <Checkbox disabled={this.state.enrichmentAccessDisabled}>
                    Enrichment access
                  </Checkbox>
                </Form.Item>
                <Form.Item
                  name="has_access_to_query_builder"
                  valuePropName="checked"
                >
                  <Checkbox disabled={this.state.queryBuilderAccessDisabled}>
                    Full Query Builder access
                  </Checkbox>
                </Form.Item>
                <Tooltip
                  title="Flag is giving access ONLY to a reduced list of query builder queries"
                  placement="bottom"
                >
                  <Form.Item
                    name="has_limited_access_to_query_builder"
                    valuePropName="checked"
                    className={styles.limitedQueryAccessCheckbox}
                  >
                    <Checkbox
                      disabled={this.state.limitedQueryBuilderAccessDisabled}
                    >
                      Limited Query Builder access
                    </Checkbox>
                  </Form.Item>
                </Tooltip>
              </div>
            </Col>

            <Col xs={24}>
              <div className={styles.flag_container}>
                <Form.Item name="has_access_to_sources" valuePropName="checked">
                  <Checkbox>Sources access</Checkbox>
                </Form.Item>
                <Form.Item
                  name="has_access_to_copy_end_point"
                  valuePropName="checked"
                >
                  <Checkbox>Automate Copy Endpoint access</Checkbox>
                </Form.Item>
                <Form.Item
                  name="has_access_to_threat_ranking"
                  valuePropName="checked"
                >
                  <Checkbox>Threat Ranking access</Checkbox>
                </Form.Item>
                <Form.Item
                  name="has_access_to_advanced_filter"
                  valuePropName="checked"
                >
                  <Checkbox>Advanced Filters access</Checkbox>
                </Form.Item>
              </div>
            </Col>
            <Col xs={24}>
              <div className={styles.flag_container}>
                <Form.Item
                  name="has_access_to_preferences"
                  valuePropName="checked"
                >
                  <Checkbox>Preferences access</Checkbox>
                </Form.Item>
                <Form.Item
                  name="has_access_to_org_settings"
                  valuePropName="checked"
                >
                  <Checkbox>Organization Settings access</Checkbox>
                </Form.Item>
                <Form.Item
                  name="has_access_to_share_unshare"
                  valuePropName="checked"
                >
                  <Checkbox>Share/Unshare access</Checkbox>
                </Form.Item>
                <Form.Item
                  name="has_access_to_monitoring"
                  valuePropName="checked"
                >
                  <Checkbox disabled={this.state.monitoringAccessDisabled}>
                    Monitoring access
                  </Checkbox>
                </Form.Item>
              </div>
            </Col>
            <Col xs={24}>
              <div className={styles.flag_container}>
                <Form.Item
                  name="has_access_to_query_history"
                  valuePropName="checked"
                >
                  <Checkbox>Query History access</Checkbox>
                </Form.Item>
                <Form.Item
                  name="has_access_to_web_scanner"
                  valuePropName="checked"
                >
                  <Checkbox>Web Scanner</Checkbox>
                </Form.Item>
                <Form.Item
                  name="has_access_to_tlp_amber_report"
                  valuePropName="checked"
                >
                  <Checkbox>TLP Amber Reports access</Checkbox>
                </Form.Item>
                <Form.Item
                  name="has_access_to_data_marketplace"
                  valuePropName="checked"
                >
                  <Checkbox>Data Marketplace access</Checkbox>
                </Form.Item>
              </div>
            </Col>
            <Col xs={24}>
              <div className={styles.flag_container}>
                <Form.Item
                  name="has_access_to_bulk_data_feeds"
                  valuePropName="checked"
                >
                  <Checkbox>Bulk Data Feeds access</Checkbox>
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row gutter={24} className={'mt-1'}>
            <Col xs={24}>
              <Title level={4}>Recipe permissions:</Title>
              <div className={styles.flag_container}>
                <Form.Item
                  name="has_access_to_brand_impersonation_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>Brand Impersonation Recipe access</Checkbox>
                </Form.Item>

                <Form.Item
                  name="has_access_to_dangling_dns_detection_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>Dangling DNS Detection Recipe access</Checkbox>
                </Form.Item>

                <Form.Item
                  name="has_access_to_dangling_dns_records_count_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>Dangling DNS Records Count Recipe access</Checkbox>
                </Form.Item>
              </div>
            </Col>
            <Col xs={24}>
              <div className={styles.flag_container}>
                <Form.Item
                  name="has_access_to_discover_shadow_it_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>Discover Shadow IT Recipe access</Checkbox>
                </Form.Item>

                <Form.Item
                  name="has_access_to_domain_name_server_changes_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>Domain Name Server Changes Recipe access</Checkbox>
                </Form.Item>

                <Form.Item
                  name="has_access_to_domain_txt_records_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>Domain TXT Records Recipe access</Checkbox>
                </Form.Item>

                <Form.Item
                  name="has_access_to_domains_hosted_on_ip_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>Domains Hosted on IP Recipe access</Checkbox>
                </Form.Item>
              </div>
            </Col>

            <Col xs={24}>
              <div className={styles.flag_container}>
                <Form.Item
                  name="has_access_to_domains_hosted_on_server_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>Domains Hosted on Server Recipe access</Checkbox>
                </Form.Item>

                <Form.Item
                  name="has_access_to_hosting_infra_asns_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>
                    Hosting Infrastructure - ASNs Recipe access
                  </Checkbox>
                </Form.Item>

                <Form.Item
                  name="has_access_to_hosting_infra_ips_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>
                    Hosting Infrastructure - IPs Recipe access
                  </Checkbox>
                </Form.Item>

                <Form.Item
                  name="has_access_to_ip_diversity_of_domain_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>IP Diversity of Domain Recipe access</Checkbox>
                </Form.Item>
              </div>
            </Col>

            <Col xs={24}>
              <div className={styles.flag_container}>
                <Form.Item
                  name="has_access_to_ips_hosting_a_domain_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>IPs Hosting a Domain Recipe access</Checkbox>
                </Form.Item>

                <Form.Item
                  name="has_access_to_latest_dns_records_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>Latest DNS Records Recipe access</Checkbox>
                </Form.Item>

                <Form.Item
                  name="has_access_to_subdomain_finder_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>Subdomain Finder Recipe access</Checkbox>
                </Form.Item>
                <Form.Item
                  name="has_access_to_name_in_txt_recipe"
                  valuePropName="checked"
                >
                  <Checkbox>Name in TXT Record Recipe access</Checkbox>
                </Form.Item>
              </div>
            </Col>
          </Row>

          {/* --- REMOVE AFTER TRANSITION --- */}
          <Row gutter={24} className={'mt-1'}>
            <Col xs={24}>
              <Title level={4}>Bulk Data Feed download permissions:</Title>

              <Select
                className={styles.bulkDataFeedsSelect}
                mode={'multiple'}
                value={currentSelectedBulkDataFeedsOptions}
                allowClear
                placeholder="Select Bulk Data Feeds"
                onChange={this.handleBulkDataFeedsSelectChange}
                getPopupContainer={(trigger) => trigger.parentNode}
                options={bulkDataFeedOptions || []}
                loading={bulkDataFeedOptionsStatus === STATUS.LOADING}
                filterOption={(input, option) => {
                  return (
                    option?.label
                      ?.toLowerCase()
                      ?.indexOf(input?.toLowerCase()) >= 0
                  );
                }}
              />

              <Button
                className="ms-05"
                type="link"
                onClick={this.handleSelectAllBulkDataFeeds}
              >
                Select all
              </Button>
            </Col>
          </Row>
          {/* --- REMOVE AFTER TRANSITION END --- */}

          <Row gutter={24} className={'mt-1'}>
            <Col xs={24}>
              <Title level={4}>Data Marketplace Permissions:</Title>
            </Col>

            <Col xs={12}>
              <Text className={styles.multiselectLabel}>
                Download permission
              </Text>
              <Select
                className={styles.dataMarketplaceFeedsSelect}
                mode={'multiple'}
                value={currentlySelectedMarketplaceDataFeedDownloadOptions}
                allowClear
                placeholder="Select Marketplace Data Feeds"
                onChange={this.handleDownloadMarketplaceDataFeedsSelectChange}
                getPopupContainer={(trigger) => trigger.parentNode}
                options={dataMarketplaceFeedOptions || []}
                loading={dataMarketplaceFeedOptionsStatus === STATUS.LOADING}
                filterOption={(input, option) => {
                  return (
                    option?.label
                      ?.toLowerCase()
                      ?.indexOf(input?.toLowerCase()) >= 0
                  );
                }}
              />

              <Button
                className="mt-05"
                type="ghost"
                onClick={this.handleSelectAllDownloadMarketplaceDataFeeds}
              >
                Select all
              </Button>
            </Col>

            <Col xs={12}>
              <Text className={styles.multiselectLabel}>
                Visibility permission
              </Text>
              <Select
                className={styles.dataMarketplaceFeedsSelect}
                mode={'multiple'}
                value={currentlySelectedMarketplaceDataFeedVisibilityOptions}
                allowClear
                placeholder="Select Marketplace Data Feeds"
                onChange={this.handleVisibleMarketplaceDataFeedsSelectChange}
                getPopupContainer={(trigger) => trigger.parentNode}
                options={dataMarketplaceFeedOptions || []}
                loading={dataMarketplaceFeedOptionsStatus === STATUS.LOADING}
                filterOption={(input, option) => {
                  return (
                    option?.label
                      ?.toLowerCase()
                      ?.indexOf(input?.toLowerCase()) >= 0
                  );
                }}
              />

              <Button
                className="mt-05"
                type="ghost"
                onClick={this.handleSelectAllVisibleMarketplaceDataFeeds}
              >
                Select all
              </Button>
            </Col>
          </Row>

          <Form.Item label="ID" name={'id'} hidden></Form.Item>
          <Form.Item label="UUID" name={'uuid'} hidden></Form.Item>
          <Form.Item
            label="organisation"
            name={'organisation'}
            hidden
          ></Form.Item>

          <Form.Item className={styles.form_buttons}>
            <Button onClick={() => this.handleCancel()}>Cancel</Button>{' '}
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Panel>
      </Form>
    );
  };

  columnsLoading = [
    {
      title: <LoadingSkeleton />,
      dataIndex: 'loading',
      key: 'loading',
    },
  ];

  columns = [
    {
      width: 50,
      render: (text, record, index) => {
        const hours_to_expire = moment(
          record?.subscription?.expiration_date,
        ).diff(moment(), 'hours');
        let title = [];
        if (record?.subscription && hours_to_expire <= -24) {
          title.push('expired subscription');
        }
        if (record?.subscription?.restricted) {
          title.push('subscription restricted');
        }
        return (
          <>
            {title.length > 0 && (
              <Tooltip title={title.join(', ')}>
                <WarningOutlined />
              </Tooltip>
            )}
          </>
        );
      },
    },
    {
      title: <ColumnTitle columnName="Organization Name" />,
      dataIndex: 'company_name',
      key: 'company_name',
      align: 'left',
    },
    {
      title: <ColumnTitle columnName="Total Users" />,
      dataIndex: 'total_users',
      key: 'total_users',
    },
    {
      title: <ColumnTitle columnName="Account Type" />,
      dataIndex: 'account_type',
      key: 'account_type',
    },
    {
      title: <ColumnTitle columnName="Subscription" />,
      dataIndex: ['subscription', 'plan'],
      key: 'subscription',
      children: [
        {
          title: <ColumnTitle columnName="Requests %" />,
          render: (row) =>
            row.subscription && (
              <Tooltip
                title={
                  row?.total_requests + '/' + row?.subscription?.requests_limit
                }
              >
                {(
                  (row?.total_requests / row?.subscription?.requests_limit) *
                  100
                ).toLocaleString() || 0}
                %
              </Tooltip>
            ),
        },
        {
          title: <ColumnTitle columnName="Seats %" />,
          render: (row) =>
            row.subscription && (
              <Tooltip
                title={row?.total_users + '/' + row?.subscription?.seats_limit}
              >
                {(
                  (row?.total_users / row?.subscription?.seats_limit) *
                  100
                ).toLocaleString() || 0}
                %
              </Tooltip>
            ),
        },
        {
          title: <ColumnTitle columnName="Created" />,
          render: (row) =>
            row?.subscription?.expiration_date
              ? moment(row?.subscription?.created).format('YYYY-MM-DD HH:mm')
              : null,
        },
        {
          title: <ColumnTitle columnName="Expires on" />,
          render: (row) =>
            row?.subscription?.expiration_date
              ? moment(row?.subscription?.expiration_date).format(
                  'YYYY-MM-DD HH:mm',
                )
              : null,
        },
      ],
    },
    {
      title: <ColumnTitle columnName="Updated on" />,
      render: (row) => moment(row?.updated).format('YYYY-MM-DD HH:mm'),
    },

    {
      title: <ColumnTitle columnName="Actions" />,
      key: 'actions',
      render: (item) => {
        return (
          <div className={styles.action_buttons}>
            <Space>
              <EditOutlined onClick={() => this.handleEditClick(item)} />
              <Dropdown
                trigger={['click']}
                overlay={
                  <Menu className="ant-dropdown-menu">
                    <Menu.Item
                      className="ant-dropdown-menu-item"
                      onClick={() => {
                        history.push(`/customer/${item.uuid}/${item.id}/users`);
                      }}
                    >
                      Users
                    </Menu.Item>
                    <Menu.Item
                      className="ant-dropdown-menu-item"
                      onClick={() => this.handleEditSubscriptionClick(item)}
                    >
                      Change Subscription
                    </Menu.Item>
                    {/* following section is avaiable to non-community orgs */}
                    {item.subscription &&
                      item.subscription.plan_uuid !==
                        '3e25b016-112d-4d25-8876-b774eab1aaa3' &&
                      item.subscription.plan_uuid !==
                        '3e25b016-112d-4d25-8876-b774eab1aaa2' && (
                        <>
                          {!item.subscription.restricted && (
                            <Tooltip
                              placement={'left'}
                              title={
                                'Restricts organization subscription to: 1 seat limit, 1 live brand limit, 1 filter profile limit, 100 daily requests, 10 sources per day, 100 total sources, 100000 iocs per source limit'
                              }
                            >
                              <Menu.Item
                                className="ant-dropdown-menu-item"
                                onClick={() =>
                                  this.props.restrictSubscriptionCustomerOrganization(
                                    item?.subscription?.uuid,
                                  )
                                }
                              >
                                Restrict Subscription
                              </Menu.Item>
                            </Tooltip>
                          )}

                          {item.subscription.restricted && (
                            <Menu.Item
                              className="ant-dropdown-menu-item"
                              onClick={() =>
                                this.props.unrestrictSubscriptionCustomerOrganization(
                                  item?.subscription?.uuid,
                                )
                              }
                            >
                              Unrestrict Subscription
                            </Menu.Item>
                          )}
                        </>
                      )}

                    {item.is_active && (
                      <Menu.Item
                        className="ant-dropdown-menu-item"
                        onClick={() => this.handleSetOrganizationInactive(item)}
                      >
                        Deactivate Organization
                      </Menu.Item>
                    )}
                    {!item.is_active && (
                      <Menu.Item
                        className="ant-dropdown-menu-item"
                        onClick={() => {
                          this.setState({ activateOrgModal: true });
                          this.setState({ currentSelectedOrganization: item });
                          this.setState({ activateOrgExpirationDate: null });
                        }}
                      >
                        Activate Organization
                      </Menu.Item>
                    )}
                    <Menu.Item
                      className="ant-dropdown-menu-item"
                      onClick={() => this.handleDeleteClick(item)}
                    >
                      <Paragraph style={{ color: 'red' }}>Delete</Paragraph>
                    </Menu.Item>
                  </Menu>
                }
              >
                <Icon component={three_dots_icon} />
              </Dropdown>
            </Space>
          </div>
        );
      },
    },
  ];

  returnLoadingTable() {
    return [
      { loading: <LoadingSkeleton /> },
      { loading: <LoadingSkeleton /> },
      { loading: <LoadingSkeleton /> },
      { loading: <LoadingSkeleton /> },
      { loading: <LoadingSkeleton /> },
    ];
  }

  renderListView = () => {
    return (
      <div className={styles.customers}>
        <div className={styles.tableHeader}>
          <Input
            id="searchSourceName"
            name="searchSourceName"
            type="text"
            onPressEnter={(e) => {
              this.state.currentPage = 1;
              this.state.searchText = e.target.value;
              this.props.loadCustomerOrganizationsListPage(
                1,
                this.state.searchText,
              );
            }}
            onChange={(e) => {
              this.state.searchText = e.target.value;
              if (e.target.value === '') {
                this.state.currentPage = 1;
                this.props.loadCustomerOrganizationsListPage(
                  1,
                  this.state.searchText,
                );
              }
            }}
            allowClear
            size="default"
            placeholder="Search organisation name or account type"
            prefix={
              <SearchOutlined style={{ color: 'rgba(255, 255, 255, 0.3)' }} />
            }
          />

          <Button
            role={'button3'}
            type="primary"
            onClick={() => this.handleAddClick()}
            disabled={this.props.customerOrganizationsStatus === STATUS.LOADING}
          >
            Add New Organisation
          </Button>
        </div>

        <Table
          className={cx(styles.customersTable, {
            [styles['loading']]:
              this.props.customerOrganizationsStatus === STATUS.LOADING,
          })}
          pagination={false}
          dataSource={
            this.props.customerOrganizationsStatus === STATUS.LOADING
              ? this.returnLoadingTable()
              : this.props.customerOrganizationsData
          }
          columns={
            this.props.customerOrganizationsStatus === STATUS.LOADING
              ? this.columnsLoading
              : this.columns
          }
          rowClassName={(record) => {
            const hours_to_expire = moment(
              record?.subscription?.expiration_date,
            ).diff(moment(), 'hours');
            return (
              record?.subscription && hours_to_expire <= 0 && styles['gray_row']
            );
          }}
        />
      </div>
    );
  };

  renderOrganizationForm = () => {
    const {
      currentSelectedBulkDataFeedsOptions, //remove after transition
      bulkDataFeedOptions, //remove after transition
      bulkDataFeedOptionsStatus, //remove after transition

      currentCustomer,
      currentlySelectedMarketplaceDataFeedDownloadOptions,
      currentlySelectedMarketplaceDataFeedVisibilityOptions,
      selectedPlan,
    } = this.state;
    const {
      dataMarketplaceFeedOptionsStatus,
      dataMarketplaceFeedOptions,
    } = this.props;

    return (
      <Form
        name="organization"
        autoComplete="off"
        initialValues={{
          uuid: currentCustomer?.uuid,
          company_name: currentCustomer?.company_name,
          city: currentCustomer?.city,
          email: currentCustomer?.email,
          address: currentCustomer?.address,
          country: currentCustomer?.country,
          phone: currentCustomer?.phone,
          has_access_to_threat_ranking:
            currentCustomer?.subscription?.has_access_to_threat_ranking,
          has_access_to_advanced_filter:
            currentCustomer?.subscription?.has_access_to_advanced_filter,
          has_access_to_sources:
            currentCustomer?.subscription?.has_access_to_sources,
          has_access_to_copy_end_point:
            currentCustomer?.subscription?.has_access_to_copy_end_point,
          has_access_to_monitoring:
            currentCustomer?.subscription?.has_access_to_monitoring,
          has_access_to_query_history:
            currentCustomer?.subscription?.has_access_to_query_history,
          has_access_to_web_scanner:
            currentCustomer?.subscription?.has_access_to_web_scanner,
          has_access_to_brand_impersonation_recipe:
            currentCustomer?.subscription
              ?.has_access_to_brand_impersonation_recipe,
          has_access_to_dangling_dns_detection_recipe:
            currentCustomer?.subscription
              ?.has_access_to_dangling_dns_detection_recipe,
          has_access_to_dangling_dns_records_count_recipe:
            currentCustomer?.subscription
              ?.has_access_to_dangling_dns_records_count_recipe,
          has_access_to_discover_shadow_it_recipe:
            currentCustomer?.subscription
              ?.has_access_to_discover_shadow_it_recipe,
          has_access_to_domain_name_server_changes_recipe:
            currentCustomer?.subscription
              ?.has_access_to_domain_name_server_changes_recipe,
          has_access_to_domain_txt_records_recipe:
            currentCustomer?.subscription
              ?.has_access_to_domain_txt_records_recipe,
          has_access_to_domains_hosted_on_ip_recipe:
            currentCustomer?.subscription
              ?.has_access_to_domains_hosted_on_ip_recipe,
          has_access_to_domains_hosted_on_server_recipe:
            currentCustomer?.subscription
              ?.has_access_to_domains_hosted_on_server_recipe,
          has_access_to_hosting_infra_asns_recipe:
            currentCustomer?.subscription
              ?.has_access_to_hosting_infra_asns_recipe,
          has_access_to_hosting_infra_ips_recipe:
            currentCustomer?.subscription
              ?.has_access_to_hosting_infra_ips_recipe,
          has_access_to_ip_diversity_of_domain_recipe:
            currentCustomer?.subscription
              ?.has_access_to_ip_diversity_of_domain_recipe,
          has_access_to_ips_hosting_a_domain_recipe:
            currentCustomer?.subscription
              ?.has_access_to_ips_hosting_a_domain_recipe,
          has_access_to_latest_dns_records_recipe:
            currentCustomer?.subscription
              ?.has_access_to_latest_dns_records_recipe,
          has_access_to_subdomain_finder_recipe:
            currentCustomer?.subscription
              ?.has_access_to_subdomain_finder_recipe,
          has_access_to_name_in_txt_recipe:
            currentCustomer?.subscription?.has_access_to_name_in_txt_recipe,

          has_access_to_enrich:
            currentCustomer?.subscription?.has_access_to_enrich,
          has_access_to_query_builder: currentCustomer?.subscription
            ?.has_limited_access_to_query_builder
            ? false
            : currentCustomer?.subscription?.has_access_to_query_builder,
          has_access_to_preferences:
            currentCustomer?.subscription?.has_access_to_preferences,
          has_access_to_org_settings:
            currentCustomer?.subscription?.has_access_to_org_settings,
          has_access_to_subscription_page:
            currentCustomer?.subscription?.has_access_to_subscription_page,
          has_access_to_share_unshare:
            currentCustomer?.subscription?.has_access_to_share_unshare,
          has_access_to_explore:
            currentCustomer?.subscription?.has_access_to_explore,
          has_limited_access_to_query_builder:
            currentCustomer?.subscription?.has_limited_access_to_query_builder,
          has_access_to_data_marketplace:
            currentCustomer?.subscription?.has_access_to_data_marketplace,
          has_access_to_tlp_amber_report:
            currentCustomer?.subscription?.has_access_to_tlp_amber_report,
          has_access_to_bulk_data_feeds:
            currentCustomer?.subscription?.has_access_to_bulk_data_feeds, //remove after transition
        }}
        onFinish={this.handleOrganizationSubmit}
        ref={this.formRef}
        layout={'vertical'}
        className={styles.organization_form}
        onValuesChange={this.handlePermissionChange}
      >
        <Panel bgcolor={'#1C3138'}>
          <div className={styles.panel_header}>
            <Title level={3}>
              {this.state.action == 'edit' ? 'Edit' : 'Create'} Organization
            </Title>
          </div>

          <Row gutter={24}>
            <Col xs={24} lg={12}>
              <Form.Item
                label="Company Name"
                name="company_name"
                rules={[
                  { required: true, message: 'Please add a company name!' },
                  { whitespace: true },
                  { max: 255, message: 'Maximum length reached!' },
                ]}
              >
                <Input maxLength={255} />
              </Form.Item>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: 'Please add an email!' },
                  {
                    type: 'email',
                    message: 'Please type a valid email address!',
                  },
                  { max: 320, message: 'Maximum length reached!' },
                ]}
              >
                <Input maxLength={320} />
              </Form.Item>
              <Form.Item name="country" label="Country">
                <CountrySelect mode="single" />
              </Form.Item>
            </Col>

            <Col xs={24} lg={12}>
              <Form.Item
                name="city"
                label="City"
                rules={[{ max: 255, message: 'Maximum length reached!' }]}
              >
                <Input maxLength={255} />
              </Form.Item>
              <Form.Item
                name="address"
                label="Address"
                rules={[{ max: 255, message: 'Maximum length reached!' }]}
              >
                <Input maxLength={255} />
              </Form.Item>
              <Form.Item
                name="phone"
                label="Phone"
                rules={[{ max: 70, message: 'Maximum length reached!' }]}
              >
                <Input maxLength={70} />
              </Form.Item>
            </Col>
          </Row>

          {this.state.action == 'add' && this.renderPlanView()}

          {this.state.action == 'add' && (
            <>
              <Row gutter={24} className={'mt-1'}>
                <Col xs={24}>
                  <Title level={4}>Permission level control:</Title>
                  <div className={styles.flag_container}>
                    <Form.Item
                      name="has_access_to_explore"
                      valuePropName="checked"
                    >
                      <Checkbox
                        data-testid="has_access_to_explore"
                        disabled={this.state.action == 'add'}
                      >
                        Explore access
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="has_access_to_enrich"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Enrichment access
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="has_access_to_query_builder"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Full Query Builder access
                      </Checkbox>
                    </Form.Item>
                    <Tooltip
                      title="Flag is giving access ONLY to a reduced list of query builder queries"
                      placement="bottom"
                    >
                      <Form.Item
                        name="has_limited_access_to_query_builder"
                        valuePropName="checked"
                        className={styles.limitedQueryAccessCheckbox}
                      >
                        <Checkbox disabled={this.state.action == 'add'}>
                          Limited Query Builder access
                        </Checkbox>
                      </Form.Item>
                    </Tooltip>
                  </div>
                </Col>

                <Col xs={24}>
                  <div className={styles.flag_container}>
                    <Form.Item
                      name="has_access_to_sources"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Sources access
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="has_access_to_copy_end_point"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Automate Copy Endpoint access
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="has_access_to_threat_ranking"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Threat Ranking access
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="has_access_to_advanced_filter"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Advanced Filters access
                      </Checkbox>
                    </Form.Item>
                  </div>
                </Col>
                <Col xs={24}>
                  <div className={styles.flag_container}>
                    <Form.Item
                      name="has_access_to_preferences"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Preferences access
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="has_access_to_org_settings"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Organization Settings access
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="has_access_to_share_unshare"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Share/Unshare access
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="has_access_to_monitoring"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Monitoring access
                      </Checkbox>
                    </Form.Item>
                  </div>
                </Col>
                <Col xs={24}>
                  <div className={styles.flag_container}>
                    <Form.Item
                      name="has_access_to_query_history"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Query History access
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="has_access_to_web_scanner"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Web Scanner
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="has_access_to_data_marketplace"
                      valuePropName="checked"
                    >
                      <Checkbox
                        data-testid="has_access_to_data_marketplace"
                        disabled={this.state.action == 'add'}
                      >
                        Data Marketplace access
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="has_access_to_tlp_amber_report"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        TLP Amber Report access
                      </Checkbox>
                    </Form.Item>
                  </div>
                </Col>
                <Col xs={24}>
                  <div className={styles.flag_container}>
                    <Form.Item
                      name="has_access_to_bulk_data_feeds"
                      valuePropName="checked"
                    >
                      <Checkbox>Bulk Data Feeds access</Checkbox>
                    </Form.Item>
                  </div>
                </Col>
              </Row>

              <Row gutter={24} className={'mt-1'}>
                <Col xs={24}>
                  <Title level={4}>Recipe permissions:</Title>
                  <div className={styles.flag_container}>
                    <Form.Item
                      name="has_access_to_brand_impersonation_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Brand Impersonation Recipe access
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="has_access_to_dangling_dns_detection_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Dangling DNS Detection Recipe access
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="has_access_to_dangling_dns_records_count_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Dangling DNS Records Count Recipe access
                      </Checkbox>
                    </Form.Item>
                  </div>
                </Col>
                <Col xs={24}>
                  <div className={styles.flag_container}>
                    <Form.Item
                      name="has_access_to_discover_shadow_it_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Discover Shadow IT Recipe access
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="has_access_to_domain_name_server_changes_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Domain Name Server Changes Recipe access
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="has_access_to_domain_txt_records_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Domain TXT Records Recipe access
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="has_access_to_domains_hosted_on_ip_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Domains Hosted on IP Recipe access
                      </Checkbox>
                    </Form.Item>
                  </div>
                </Col>

                <Col xs={24}>
                  <div className={styles.flag_container}>
                    <Form.Item
                      name="has_access_to_domains_hosted_on_server_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Domains Hosted on Server Recipe access
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="has_access_to_hosting_infra_asns_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Hosting Infrastructure - ASNs Recipe access
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="has_access_to_hosting_infra_ips_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Hosting Infrastructure - IPs Recipe access
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="has_access_to_ip_diversity_of_domain_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        IP Diversity of Domain Recipe access
                      </Checkbox>
                    </Form.Item>
                  </div>
                </Col>

                <Col xs={24}>
                  <div className={styles.flag_container}>
                    <Form.Item
                      name="has_access_to_ips_hosting_a_domain_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        IPs Hosting a Domain Recipe access
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="has_access_to_latest_dns_records_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Latest DNS Records Recipe access
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="has_access_to_subdomain_finder_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Subdomain Finder Recipe access
                      </Checkbox>
                    </Form.Item>

                    <Form.Item
                      name="has_access_to_name_in_txt_recipe"
                      valuePropName="checked"
                    >
                      <Checkbox disabled={this.state.action == 'add'}>
                        Name in TXT Record Recipe access
                      </Checkbox>
                    </Form.Item>
                  </div>
                </Col>
              </Row>

              {/* --- REMOVE AFTER TRANSITION --- */}
              <Row gutter={24} className={'mb-1'}>
                <Col xs={24} className="mt-1">
                  <Title level={4}>Bulk Data Feed Download permissions:</Title>

                  <Select
                    disabled={
                      selectedPlan !== '3e25b016-112d-4d25-8876-b774eab1aaa1' ||
                      selectedPlan === null
                    }
                    className={styles.bulkDataFeedsSelect}
                    mode={'multiple'}
                    value={currentSelectedBulkDataFeedsOptions}
                    allowClear
                    placeholder="Select Bulk Data Feeds"
                    onChange={this.handleBulkDataFeedsSelectChange}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    options={bulkDataFeedOptions || []}
                    loading={bulkDataFeedOptionsStatus === STATUS.LOADING}
                    filterOption={(input, option) => {
                      return (
                        option?.label
                          ?.toLowerCase()
                          ?.indexOf(input?.toLowerCase()) >= 0
                      );
                    }}
                  />
                </Col>
              </Row>
              {/* --- REMOVE AFTER TRANSITION END --- */}

              <Row gutter={24} className={'mb-1, mt-1'}>
                <Col xs={24} className="mt-1">
                  <Title level={4}>Data Marketplace Permissions:</Title>
                </Col>

                <Col xs={12}>
                  <Text className={styles.multiselectLabel}>
                    Download permission
                  </Text>
                  <Select
                    label={'label'}
                    disabled={
                      selectedPlan !== '3e25b016-112d-4d25-8876-b774eab1aaa1' ||
                      selectedPlan === null
                    }
                    className={styles.dataMarketplaceFeedsSelect}
                    mode={'multiple'}
                    value={currentlySelectedMarketplaceDataFeedDownloadOptions}
                    allowClear
                    placeholder="Select Marketplace Data Feeds"
                    onChange={
                      this.handleDownloadMarketplaceDataFeedsSelectChange
                    }
                    getPopupContainer={(trigger) => trigger.parentNode}
                    options={dataMarketplaceFeedOptions || []}
                    loading={
                      dataMarketplaceFeedOptionsStatus === STATUS.LOADING
                    }
                    filterOption={(input, option) => {
                      return (
                        option?.label
                          ?.toLowerCase()
                          ?.indexOf(input?.toLowerCase()) >= 0
                      );
                    }}
                  />

                  <Button
                    className="mt-05"
                    type="ghost"
                    onClick={this.handleSelectAllDownloadMarketplaceDataFeeds}
                  >
                    Select all
                  </Button>
                </Col>

                <Col xs={12}>
                  <Text className={styles.multiselectLabel}>
                    Visibility permission
                  </Text>
                  <Select
                    disabled={
                      selectedPlan !== '3e25b016-112d-4d25-8876-b774eab1aaa1' ||
                      selectedPlan === null
                    }
                    className={styles.dataMarketplaceFeedsSelect}
                    mode={'multiple'}
                    value={
                      currentlySelectedMarketplaceDataFeedVisibilityOptions
                    }
                    allowClear
                    placeholder="Select Marketplace Data Feeds"
                    onChange={
                      this.handleVisibleMarketplaceDataFeedsSelectChange
                    }
                    getPopupContainer={(trigger) => trigger.parentNode}
                    options={dataMarketplaceFeedOptions || []}
                    loading={
                      dataMarketplaceFeedOptionsStatus === STATUS.LOADING
                    }
                    filterOption={(input, option) => {
                      return (
                        option?.label
                          ?.toLowerCase()
                          ?.indexOf(input?.toLowerCase()) >= 0
                      );
                    }}
                  />

                  <Button
                    className="mt-05"
                    type="ghost"
                    onClick={this.handleSelectAllVisibleMarketplaceDataFeeds}
                  >
                    Select all
                  </Button>
                </Col>
              </Row>
            </>
          )}

          <Form.Item label="ID" name={'id'} hidden></Form.Item>
          <Form.Item label="UUID" name={'uuid'} hidden></Form.Item>
          <Form.Item className={styles.actionButtons}>
            <Button onClick={() => this.handleCancel()}>Cancel</Button>{' '}
            <Button type="primary" htmlType="submit" className="ms-05">
              Save
            </Button>
          </Form.Item>
        </Panel>
      </Form>
    );
  };

  render() {
    const { action, currentCustomer, currentCustomerSubscription } = this.state;
    const isLoading = this.props.customerOrganizationsStatus === STATUS.LOADING;

    const renderSwitch = (action) => {
      switch (action) {
        case 'edit':
        case 'add':
          return this.renderOrganizationForm();
        case 'editSubscription':
          return this.renderSubscriptionForm();
        default:
          return this.renderListView();
      }
    };

    const tablePagination = (
      <Pagination
        showSizeChanger={false}
        current={this.state.currentPage ? this.state.currentPage : 1}
        total={this.props.customerOrganizationsCount}
        pageSize={20}
        onChange={(current, pageSize) => {
          window.scrollTo(0, 0);
          this.state.currentPage = current;
          this.props.loadCustomerOrganizationsListPage(
            this.state.currentPage,
            this.state.searchText ? this.state.searchText : '',
          );
        }}
      />
    );

    return this.props.mySubscriptionPlanStatus === STATUS.LOADED ||
      this.props.mySubscriptionPlanStatus === STATUS.ERROR ? (
      <>
        {action && action !== 'list' ? (
          <div
            className="threatRankingBackButton"
            onClick={() => this.handleBackClick()}
          >
            <span
              style={{
                fontSize: '12px',
                color: 'white',
                opacity: '0.65',
                textAlign: 'left',
              }}
            >
              <>
                <ArrowLeftOutlined /> <span>Back</span>
              </>
            </span>
          </div>
        ) : (
          <></>
        )}
        <div className={styles.header}>
          <Title level={2}>
            {currentCustomer
              ? currentCustomer?.company_name
              : currentCustomerSubscription
              ? currentCustomerSubscription.company_name
              : null}
          </Title>
          {action && action !== 'list' ? '' : tablePagination}
        </div>

        {!isLoading ? renderSwitch(action) : this.renderListView()}

        <div className={styles.bottomTablePagination}>
          {action && action !== 'list' ? '' : tablePagination}
        </div>

        <Modal
          className={styles.activateOrgModal}
          title="Activate Organization"
          centered
          closable={false}
          open={this.state.activateOrgModal}
          width={400}
          footer={[
            <Button
              key="cancel"
              type="link"
              onClick={() => this.setState({ activateOrgModal: false })}
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={this.state.activateOrgLoading}
              onClick={() => this.handleSetOrganizationActive()}
              disabled={!this.state.activateOrgExpirationDate}
            >
              Activate
            </Button>,
          ]}
        >
          <Text>Please select an expiration date</Text>
          <DatePicker
            autoFocus
            value={
              this.state.activateOrgExpirationDate
                ? moment(this.state.activateOrgExpirationDate)
                : null
            }
            onChange={this.handleOrgModalDatePickerChange}
            disabledDate={(date) => {
              return date.isBefore(moment());
            }}
            format="YYYY-MM-DD"
          />
        </Modal>

        <VersionCheck
          parentComponentStatus={this.props.customerOrganizationsStatus}
        />
      </>
    ) : (
      <LoadingSilentPush size={80} positionCenter />
    );
  }
}

export default Customers;
